<template>
  <div id="app" class="container">
    <div class="columns is-centered is-multiline content has-text-left" id="print-wrapper">
      <div class="column is-full">
        <br />
        <br />

        <p class="is-size-6 has-text-weight-semibold">
          Hier können Sie weitere Angaben zum Lagerort und Ihre persönlichen
          Daten angeben. Diese Informationen werden Ihnen dann im PDF-Ausdruck
          im Kopf abgedruckt.
        </p>
        <div class="columns">
          <div class="column is-half">
            <timber-person-info-form v-bind:personInfo="personInfo" />
          </div>

          <div class="column is-half">
            <timber-wood-info-form v-bind:woodInfo="woodInfo" />
          </div>
        </div>

        <br />
      </div>
      <div class="column is-full">
        <div class="control">
          <span
            style="border-bottom: 1px dotted black; padding-bottom: 0.5em;"
            data-balloon-length="medium"
            aria-label="Für den Rindenabzug lt. den Bestimmungen. "
            data-balloon-pos="up"
          >
            <label class="radio">
              <input
                type="radio"
                name="woodMesaureMethod"
                v-model="woodMesauredWithBark"
                v-bind:value="true"
                data-cy="woodMesauredWithBark-button"
              />
              Maße mit Rinde
            </label>
            <label class="radio">
              <input
                type="radio"
                name="woodMesaureMethod"
                v-model="woodMesauredWithBark"
                v-bind:value="false"
                data-cy="woodMesauredWithoutBark-button"
              />
              Maße ohne Rinde
            </label>
          </span>
        </div>

        <br />

        <form id="woodlist">
          <timber-table
            v-bind:rows="rows"
            v-bind:measuredWithBark="woodMesauredWithBark"
            v-bind:totalVolume="round(totalVolume)"
            v-on:remove-all-rows="removeAllRows"
          />
        </form>

        <br />
      </div>

      <div class="column is-one-third">
        <timber-file-output
          v-bind:measuredWithBark="woodMesauredWithBark"
          v-bind:personInfo="personInfo"
          v-bind:woodInfo="woodInfo"
          v-bind:rows="rows"
          v-bind:woodResults="woodResults"
          v-bind:versionNumber="versionNumber"
        />
      </div>
      <div class="column is-one-third">
        <timber-table-average-results
          v-bind:rows="rows"
          v-bind:woodMesauredWithBark="woodMesauredWithBark"
          v-bind:totalVolume="round(totalVolume)"
        />
      </div>
      <div class="column is-one-third">
        <timber-table-full-results
          @resultsChanged="updateWoodResults"
          v-bind:rows="rows"
          v-bind:woodMesauredWithBark="woodMesauredWithBark"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TimberTable from "./components/TimberTable.vue";
import TimberWoodInfoForm from "./components/TimberWoodInfoForm.vue";
import TimberPersonInfoForm from "./components/TimberPersonInfoForm.vue";
import TimberFileOutput from "./components/TimberFileOutput.vue";
import TimberTableFullResults from "./components/TimberTableFullResults.vue";
import TimberTableAverageResults from "./components/TimberTableAverageResults.vue";
import helperMixin from "./mixins/helper-mixin.js";

export default {
  name: "app",
  mixins: [helperMixin],
  components: {
    TimberTable,
    TimberWoodInfoForm,
    TimberPersonInfoForm,
    TimberFileOutput,
    TimberTableFullResults,
    TimberTableAverageResults
  },
  mounted: function() {
    this.rows = getInitialArray();
  },
  data() {
    return {
      versionNumber: "1.0.5",

      woodMesauredWithBark: true,
      woodResults: [],
      rows: [],
      woodInfo: {
        location: "",
        cuttingTime: "",
        amountOfStacks: "",
        notes: ""
      },
      personInfo: {
        name: "",
        phone: "",
        street: "",
        streetNumber: "",
        zipcode: "",
        city: "",
        taxId: ""
      }
    };
  },
  computed: {
    totalVolume: function() {
      return this.rows
        .map(function(m) {
          return m.volume;
        })
        .reduce(function(accumulator, r) {
          return accumulator + Number(r);
        }, 0.0);
    }
  },
  methods: {
    removeAllRows: function() {
      this.rows = getInitialArray();
    },
    updateWoodResults: function(newValue) {
      this.woodResults = newValue;
    }
  }
};

function getInitialArray() {
  return [
    {
      id: 1,
      logNumber: "00001",
      woodType: "Fichte",
      length: "",
      diameter: "",
      diameterWithoutBark: "",
      strengthClass: "",
      quality: "B",
      volume: 0.0,
      note: ""
    }
  ];
}
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
